require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-inclusive-banking.json") })
        }
      }, "path---articles-tags-inclusive-banking");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-inclusive-banking!./.cache/json/articles-tags-inclusive-banking.json
// module id = 1845
// module chunks = 231608221292675